import * as constants from "./constants";
import patchApi from "@/api/patch";
import appApi from '@/api/app'
import {$public} from '@/utils';
// 更新采集列表状态
export const changePatchList = (data, type) => {
    return {
        type: type,
        data
    };
};

//获取采集点数据列表
export const getPatchList = (data) => {
    return (dispatch) => {
        patchApi.getPatchList(data)
            .then(res => {
                const _data = res || {content: []};
                dispatch(changePatchList(_data, constants.PATCH_DATA_LIST));
            })
    };
};

//获取采集点数据 详情
export const getPatchDetail = (data) => {
    return (dispatch) => {
        patchApi.getPatchDetail(data)
            .then(res => {
                const _data = res || {};
                dispatch({
                    type: constants.PATCH_DATA_DETAIL,
                    data: _data,
                });
            })
    };
};


//获取采集点 设备列表数据
export const getPatchOfDeviceList = (data) => {
    return (dispatch) => {
        patchApi.getPatchOfDeviceList(data)
            .then(res => {
                const _data = res || {content: []};
                //数据
                dispatch({
                    type: constants.PATCH_DEVICE_LIST,
                    data: _data,
                });
            })
    };
};

//获取采集点下越级查询 设备列表数据
export const getPatchOfDeviceListAll = (data) => {
    return new Promise(resolve => {
        patchApi.getPatchOfDeviceListAll(data)
            .then(res => {
                resolve(res)
            })
    })
};
//下发时段到采集点
export const writeTimeOptionToMeter = (data) => {
    return (dispatch) => {
        patchApi.writeTimeToOption(data)
            .then(res => {
                if(res) $public.suc('操作成功');
            })
    };
};

//查询搜索下拉列表数据  --弃用20210803
export const getDeviceTypeList = () => {
    return (dispatch) => {
        const _data = [
            {code: 'gateway', name: '网关'},
            {code: 'device', name: '直连设备'},
        ];
        dispatch({
            type: constants.DEVICE_TYPE_LIST,
            data: _data,
        });
    };
};


//删除采集点
export const deletePatch = (id) => {
    return (dispatch) => {
        return new Promise(resolve => {
            patchApi.deletePatch(id)
                .then(res => {
                    resolve(res);
                })
        });
    };
};

//创建采集点 / 编辑
export const createPatch = (data, isEdit) => {
    return (dispatch) => {
        if(isEdit) return patchApi.updatePatch(data);  //返回promise
        return patchApi.createPatch(data);  //返回promise
    };
};



//查询子设备列表
export const getChildDeviceList = (data) => {
    return (dispatch) => {
        patchApi.getChildDeviceList(data)
            .then(res => {
                const _data = res || {content: []};
                dispatch({
                    type: constants.CHILD_DEVICE_DATA_LIST,
                    data: _data,
                });
            })
    };
};


//查查询未添加到采集点的设备列表
export const getUnPatchDeviceList = (data) => {
    return (dispatch) => {
        patchApi.getUnPatchDeviceList(data)
            .then(res => {
                const _data = res || {content: []};
                dispatch({
                    type: constants.UN_PATCH_DEVICE_DATA_LIST,
                    data: _data,
                });
            })
    };
};


//添加设备到采集点
export const addDevicesToPatch = (data) => {
    return (dispatch) => {
        return patchApi.addDevicesToPatch(data);
    };
};


//从采集点列表删除设备
export const deleteDeviceOfPatchList = (id) => {
    return (dispatch) => {
        return patchApi.deleteDeviceOfPatchList(id);
    };
};


//查询子采集点列表
export const getChildPatchList = (data) => {
    return (dispatch) => {
        patchApi.getChildPatchList(data)
            .then(res => {
                const _data = res || {content: []};
                dispatch({
                    type: constants.CHILD_PATCH_DATA_LIST,
                    data: _data,
                });
            })
    };
};

export const addGetWay = (data) => {
    return (dispatch) => {
        return appApi.addGetway(data);  //返回promise
    };
};

export const getProductList = () => {
    return (dispatch) => {
        appApi.getProductList()
            .then(res => {
                if(res){
                    dispatch(sucGetProtocolList(res,'productList'));
                }
            })
    };
};

//获取字典数据  通讯协议与连接方式
const sucGetProtocolList = (data,dictCode) => {
    return {
        type: constants[dictCode],
        data
    };
};

export const getAssetCodeInfo = (data) => {
    return new Promise((resolve,reject) => {
        appApi.getAssetCodeInfo(data)
            .then(res => {
                if(res){
                    getDeviceNoAndlogical(res)
                    resolve(res)
                }else{
                    reject()
                }
            })
    })
};

const getDeviceNoAndlogical = (v)=>{
    v.logicalAddress = v.logicalAddress || ''
    v.deviceNo = v.deviceNo || ''
    if(!v.detail){
        return
    }
    v.detail.forEach(v1=>{
        if(v1.codeType == 1){
            v.logicalAddress = v1.deviceNo
        }else if(v1.codeType == 2){
            v.deviceNo = v1.deviceNo
        }
    })
}

export const delGateway = (data) =>{
    return (dispatch) => {
        return new Promise(resolve => {
            appApi.delGetway(data)
                .then(res => {
                    resolve(res);
                })
        });
    };
}
